module.exports = __webpack_public_path__ + "static/img/blank_wftx.3eda7ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blank_wftx.png
// module id = kYoU
// module chunks = 0